export enum QuoteStatus {
    open = "open",
    finalized = "finalized",
    canceled = "canceled",
    ordered = "ordered"
}

export enum PriceType {
    list = "list",
    dealer = "dealer",
    direct = "direct"
}
